import { useState, useCallback } from "react";
import { useFetcher } from "rest-hooks";
import { BuyoutCalculationEndpoint, isErrorFromCalculation } from "../endpoints/BuyoutCalculation";
export const useBuyoutCalculation = () => {
    const [calculation, setCalculation] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const getBuyoutCalculation = useFetcher(BuyoutCalculationEndpoint);
    const handleGetBuyoutCalculation = useCallback(async (params) => {
        setCalculation(null);
        setError(null);
        setIsLoading(true);
        try {
            const result = await getBuyoutCalculation(params);
            if (!result) {
                setError("No response received from server");
                return;
            }
            if (isErrorFromCalculation(result)) {
                const errorMessage = result.error ||
                    (result.errors && result.errors.length > 0
                        ? result.errors.join(", ")
                        : "Calculation failed");
                setError(errorMessage);
            }
            else {
                setCalculation(result);
            }
        }
        catch (error) {
            console.error("Calculation failed", error);
            const errorMessage = error instanceof Error
                ? `Calculation failed: ${error.message}`
                : "Calculation failed due to network or server error";
            setError(errorMessage);
        }
        finally {
            setIsLoading(false);
        }
    }, [getBuyoutCalculation]);
    const reset = useCallback(() => {
        setCalculation(null);
        setError(null);
    }, []);
    return {
        calculation,
        error,
        isLoading,
        handleGetBuyoutCalculation,
        reset
    };
};
//# sourceMappingURL=useBuyoutCalculation.js.map